import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import Application from './modules/application'
import requests from 'vuex-requests/src/store/modules/requests'
import charts from './modules/charts'
import clients from './modules/clients'
import appointments from './modules/appointments'
import communications from './modules/communications'

export default new Vuex.Store({
  modules: {
    // requests: vuex-requests
    application: Application,
    requests: requests,
    charts: charts,
    clients: clients,
    communications: communications,
    appointments: appointments
  }
})




// WEBPACK FOOTER //
// ./src/store/index.js